// Obtiene el token del usuario
export function getToken() {
    return localStorage.getItem('token');
}

// Setea el token del usuario
export function setToken(token) {
    localStorage.setItem('token', token);
}

// Elimina el token del usuario
export function removeToken() {
    localStorage.removeItem('token');
}